module.exports = __webpack_public_path__ + "img/toprule_right01.81a43763.png";